import React, { useMemo } from 'react';
import { Card as AntCard } from 'antd';
import classNames from 'classnames';
import { MoreOutlined } from '@ant-design/icons';

import './NewRMCard.scss';

/**
 * Base RMCard Component
 *
 * Ant Design Card component with theming
 */
export const NewRMCard = ({ children, className = '', showMoreIcon = true, onMoreClick, ...props }) => {
    return (
        <AntCard className={classNames('new-rm-card', className)} {...props}>
            <div className="rm-card-container">
                <div className="rm-card-content">{children}</div>
                {showMoreIcon && <MoreOutlined className="rm-card-more-icon" onClick={onMoreClick} />}
            </div>
        </AntCard>
    );
};

export default NewRMCard;
